import React, { useRef } from "react";
import { ArrowLeft, ArrowRight } from "lucide-react";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/navigation";
import { Navigation } from "swiper/modules";

import Product1 from "../../assets/products/product1.jpg";
import Product2 from "../../assets/products/product2.png";
import Product3 from "../../assets/products/product3.png";
import Product4 from "../../assets/products/product4.png";
import { Link } from "react-router-dom";

const products = [
  { id: 1, name: "Jakne për femra", price: "239.90", image: Product1 },
  { id: 2, name: "Jakne për motorrë", price: "359.90", image: Product2 },
  { id: 3, name: "Jakne për Racing", price: "430.90", image: Product3 },
  { id: 4, name: "Aksesorë", price: "180.90", image: Product4 },
  { id: 5, name: "Aksesorë", price: "180.90", image: Product1 }
];

const ProductSection = () => {
  const swiperRef = useRef(null);

  return (
    <div className="py-16 px-4 md:px-10 lg:px-20 bg-white text-black relative">
      <div className="flex justify-between items-center mb-8">
        <h2 className="text-3xl md:text-4xl font-bold">Të zgjedhura për ty</h2>
        <Link to="/products">
          <div className="flex items-center">
            <span className="mr-2 text-sm hidden md:block">Shop All New Items</span>
            <ArrowRight size={18} />
          </div>
        </Link>
      </div>
      <div className="relative">
        <button
          className="absolute left-0 top-1/2 -translate-y-1/2 z-10"
          onClick={() => swiperRef.current?.slidePrev()}
        >
          <svg width="15" height="25" viewBox="0 0 15 25" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path fill-rule="evenodd" clip-rule="evenodd" d="M11.9184 24.3894C12.4422 24.9032 13.2895 24.9015 13.8112 24.3856C14.2892 23.9127 14.3275 23.1718 13.9273 22.6559L13.8073 22.5212L3.73399 12.6397L13.8112 2.67062C14.2892 2.1977 14.3277 1.45692 13.9273 0.940904L13.8073 0.806129C13.3272 0.335128 12.5752 0.297309 12.0514 0.691663L11.9146 0.809927L0.893222 11.7117C0.415195 12.1846 0.376719 12.9255 0.777064 13.4414L0.89712 13.5762L11.9184 24.3894Z" fill="black" />
          </svg>

        </button>

        <button
          className="absolute right-0 top-1/2 -translate-y-1/2 z-10"
          onClick={() => swiperRef.current?.slideNext()}
        >
          <svg width="15" height="25" viewBox="0 0 15 25" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path fill-rule="evenodd" clip-rule="evenodd" d="M2.78667 24.3894C2.26287 24.9032 1.41554 24.9015 0.893927 24.3856C0.4159 23.9127 0.377546 23.1718 0.777769 22.6559L0.897823 22.5212L10.9711 12.6397L0.893927 2.67062C0.4159 2.1977 0.377424 1.45692 0.777769 0.940904L0.897823 0.806129C1.37792 0.335128 2.12991 0.297309 2.65371 0.691663L2.79045 0.809927L13.8119 11.7117C14.2899 12.1846 14.3284 12.9255 13.928 13.4414L13.808 13.5762L2.78667 24.3894Z" fill="black" />
          </svg>

        </button>
        <Swiper
          onSwiper={(swiper) => (swiperRef.current = swiper)}
          slidesPerView={1}
          spaceBetween={20}
          modules={[Navigation]}
          breakpoints={{
            640: { slidesPerView: 2 },
            1024: { slidesPerView: 3 },
            1280: { slidesPerView: 4 }
          }}
        >
          {products.map((product) => (
            <SwiperSlide key={product.id}>
              <div className="group">
                <div className="mb-4 overflow-hidden">
              <Link to="/products">
                  <img
                    src={product.image}
                    alt={product.name}
                    className="w-full h-64 object-contain object-center transition-transform duration-300 group-hover:scale-105"
                  />
                </Link>
                </div>
                <div className="text-left">
                  <h3 className="text-base font-medium mb-1">{product.name}</h3>
                  <p className="text-gray-600">${product.price}</p>
                </div>
              </div>
            </SwiperSlide>
          ))}
        </Swiper>
      </div>
    </div>
  );
};

export default ProductSection;
